/* eslint pinterest/no-translation-outside-of-function:0 */

import i18n from 'app/common/lib/i18n';
import pubSub from 'app/common/lib/PubSub';
import User from 'app/common/react/components/common/User/User';
import { showError } from 'app/common/react/components/growth/unauth/lib/ErrorUtils';
import { trackRegisterActionWithClientData } from 'app/common/lib/util/trackRegisterAction';

const facebookLoader = () =>
  import(/* webpackChunkName: "FacebookCommon" */ 'app/common/lib/Facebook');

export default class SocialConnect {
  connect(network, options) {
    trackRegisterActionWithClientData(`unauth_web.social_connect.${network}`);
    window.addEventListener('message', (e) => {
      const origin =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
      if (e.origin !== origin) {
        return;
      }
      if (e.data.type === 'social-connect-complete') {
        this.complete(e.data);
      }
    });

    if (options.rerequest_facebook_email) {
      facebookLoader().then(({ default: Facebook }) => {
        // Use FB javascript SDK to make rerequest for an email
        Facebook.ensureInit((_fb) => {
          _fb.login(
            (response) => {
              const authResponse = response.authResponse;
              let grantedScopes, userId;
              if (authResponse) {
                grantedScopes = authResponse.grantedScopes;
                if (grantedScopes) {
                  grantedScopes = grantedScopes.split(',');
                }
                userId = authResponse.userID;
              }

              const emailScope = grantedScopes.indexOf('email') > -1;

              const connectData = { id: userId };

              if (response.status === 'connected' && emailScope) {
                options.success(connectData);
              } else {
                options.error(connectData);
              }
              options.complete();
            },
            {
              scope: 'email',
              auth_type: 'rerequest',
              return_scopes: true,
            },
          );
        }, User);
      });
    } else if (
      network === 'facebook' &&
      options.inClientSideFBSocialConnectExp &&
      options.inClientSideFBSocialConnectExp.enabled()
    ) {
      facebookLoader().then(({ default: Facebook }) => {
        // Use FB javascript SDK to make rerequest for an email
        Facebook.ensureInit((_fb) => {
          _fb.login(
            (response) => {
              const authResponse = response.authResponse;
              let userId, access_token;
              if (authResponse) {
                userId = authResponse.userID;
                access_token = authResponse.accessToken;
              }
              const connectData = {
                id: userId,
                access_token,
              };

              if (response.status === 'connected') {
                options.success(connectData);
              } else {
                options.error(connectData);
              }
              if ('complete' in options) {
                options.complete();
              }
            },
            {
              scope: 'email, user_likes, user_birthday, user_friends',
            },
          );
        }, User);
      });
    } else {
      const windowOptions = this.getWindowOptions();
      const c = window.open('/connect/' + network + '/', '', windowOptions);

      if (!c) {
        showError(i18n._('You must enable popups!'));
        options.error({ network, alertedUpstream: true });
        return;
      }

      // Periodically check for whether the window has been closed, in
      // case we don't have a successful connect event.
      const intervalId = setInterval(() => {
        if (c.closed) {
          clearInterval(intervalId);
          this.handleComplete({
            network,
            error_message: 'Window closed.', // TODO: i18n
          });
        }
      }, 1000);

      // This will remove itself after the first trigger.
      pubSub.instance.subscribe(
        PCONST.PUBSUB_CHANNEL_SITE,
        PCONST.PUBSUB_TOPIC_SOCIAL_CONNECT_COMPLETED,
        (channel, topic, connectData) => {
          clearInterval(intervalId);
          if (connectData.error_message) {
            options.error(connectData);
          } else {
            options.success(connectData);
          }
          if ('complete' in options) {
            options.complete();
          }
        },
      );
    }
  }

  getWindowOptions() {
    const windowWidth = 580;
    const windowHeight = 400;
    const screenWidth = screen.width;
    const screenHeight = screen.height;
    const windowLeft = Math.round((screenWidth - windowWidth) / 2);
    const windowTop =
      screenHeight > windowHeight ? Math.round((screenHeight - windowHeight) / 2) : 0;

    return (
      'scrollbars=yes,resizable=yes,toolbar=no,location=yes,' +
      'width=' +
      windowWidth +
      ',height=' +
      windowHeight +
      ',' +
      'left=' +
      windowLeft +
      ',top=' +
      windowTop
    );
  }

  /**
   * Called by SocialConnectPopup when the social network connection has been established.
   * We intentionally pass JSON-encoded strings between windows instead of passing objects.
   * IE 7-8 have quirks passing objects between windows.
   * See: http://goo.gl/8DhCe
   *
   * @param {string} data JSON-encoded data specific to the social network
   */
  complete(data) {
    this.handleComplete(data);
  }

  /**
   * Dispatch the social network connect result to interested listeners.
   *
   * @param {!Object} data Social network-specifc data
   */
  handleComplete(data) {
    //        var key = 'connect:' + data['network'];
    const network = data.network;
    if (network === 'facebook') {
      const facebook_id = data.id;
      if (facebook_id && typeof facebook_id !== 'string') {
        data.error_message = 'Facebook id must be of string type';
      }
    }
    // Trigger all the callbacks.
    pubSub.instance.publish(
      PCONST.PUBSUB_CHANNEL_SITE,
      PCONST.PUBSUB_TOPIC_SOCIAL_CONNECT_COMPLETED,
      data,
    );
  }
}
